import File from './file'
import isEmpty from 'lodash/isEmpty'
import { isModuleInFinalBuild } from '@/global/moduleList'

// noinspection JSUnresolvedFunction
const requireContext = require.context('@/modules', true, /\.js$/)

export default class ModuleDirectoryScanner {
  files = []

  constructor () {
    this.files = requireContext
      .keys()
      .map(fileFullPath => this._createFileObject(fileFullPath))

    this._dropFilesOfModulesLeftOutFromFinalBuild()
    // Narrowing has to happen before the contents are required. `_loadFileContents`
    // evaluates every file it is left with, and evaluating a module's composables
    // and configs drags in the .vue components they reference - which puts whoever
    // pulled this scanner in (the store) in an import cycle with those components.
    // A component caught mid-cycle registers as `undefined` on its parent, which
    // surfaces as "Unknown custom element" on screens that have nothing to do with
    // the file that closed the cycle.
    this._only(file => this._isWantedFile(file))
    this._loadFileContents()
  }

  /**
   * Which of the scanned files this scanner actually needs. Subclasses narrow this
   * down; everything they exclude is never evaluated.
   */
  _isWantedFile () {
    return true
  }

  _only (callback) {
    this.files = this.files.filter(file => callback(file))
  }

  _createFileObject (fileFullPath) {
    return new File(fileFullPath)
  }

  _dropFilesOfModulesLeftOutFromFinalBuild () {
    this._only(file => isModuleInFinalBuild(file.getModuleName()))
  }

  _loadFileContents () {
    this.files.forEach(file => {
      const fileContent = requireContext(file.getFullPath())
      file.setContent(fileContent.default || fileContent)
    })
  }

  withoutEmptyFiles () {
    this._only(file => !isEmpty(file.getContent()))

    return this
  }

  getAllFiles () {
    return this.files
  }
}
